import TableList from "@components/templates/tablelist";
import { HttpFindByPage,HttpBypass,HttpAccept,HttpDenied,HttpDel } from "@/service/ucadm";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            // formData: {},
            Tools: { show: true },
            Searchs: {
                show: false,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    components: {
        compUpdate
    },
    created () {
        this.startUp = 1
    },
    methods: {
        ajaxRequest:HttpFindByPage,
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "query":
                    this.$router.push({
                        name: 'registUpdate',
                        params: { type: "query" },
                        query: { id: params },
                    });
                    break;
                case "accept":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "是否通过该审批",
                        ajaxRequest: HttpAccept
                    };
                    break;
                case "pass":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "是否忽略该审批",
                        ajaxRequest: HttpBypass
                    };
                    break;
                case "denied":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: "是否拒绝该审批",
                        ajaxRequest: HttpDenied
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: "是否删除该审批",
                        ajaxRequest: HttpDel
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: "详情",
                    show: true,
                    params: id,
                    operate: "query"
                },
                {
                    label: "审批同意",
                    show: true,
                    params: id,
                    show:row.status == 1,
                    operate: "accept"
                },
                {
                    label: "审批忽略",
                    show: true,
                    params: id,
                    show:row.status == 1,
                    operate: "pass"
                },
                {
                    label: "审批拒回",
                    show: true,
                    params: id,
                    show:row.status == 1,
                    operate: "denied"
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "del"
                },
            ];
        },
        getStatusMap(state) {
            let statusMap = {
                0: {
                    "name": this.$t('uc.registration_status.unspecified',{defaultValue:'未明确'}),
                    "label": "unspecified",
                    "tag": {
                        "color":"default"
                    }
                },
                1: {
                    "name": this.$t('uc.registration_status.committed',{defaultValue:'待审核'}),
                    "label": "committed",
                    "tag": {
                        "color":"warning"
                    }
                },
                2: {
                    "name": this.$t('uc.registration_status.denied',{defaultValue:'审批拒回'}),
                    "label": "denied",
                    "tag": {
                        "color":"error"
                    }
                },
                3: {
                    "name": this.$t('uc.registration_status.accept',{defaultValue:'审批同意'}),
                    "label": "accept",
                    "tag": {
                        "color":"success"
                    }
                },
                4: {
                    "name": this.$t('uc.registration_status.assigned',{defaultValue:'审批通过'}),
                    "label": "assigned",
                    "tag": {
                        "color":"success"
                    }
                },
                5: {
                    "name": this.$t('uc.registration_status.bypass',{defaultValue:'审批忽略'}),
                    "label": "bypass",
                    "tag": {
                        "color":"default"
                    }
                }
            };
            return statusMap[state];
        },
        link(id){
            this.$router.push({
                name: 'registUpdate',
                params: { type: "query" },
                query: { id: id },
            });
        }
    },
    computed: {
        ToolsData() {
            return [
            ];
        },
        SearchsData() {
            return [
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('global.common.name',{defaultValue:'名称'}),
                    key: "userName",
                    sortable: true
                },
                {
                    title: this.$t('global.common.email',{defaultValue:'邮箱'}),
                    key: "userLoginEmail",
                    render: (h, { row }) => {
                        let href = <a onClick={() => {this.link(row.id)}}>{row.userLoginEmail}</a>
                        return href
                    }
                },
                {
                    title: this.$t('global.common.auditstatus',{defaultValue:'审核状态'}),
                    key: "status",
                    render: (h, { row }) => {
                        let status = this.getStatusMap(row.status);
                        // let statusEle = <span>{status.name}</span>;
                        let statusEle = <tag color={status.tag.color}>{status.name}</tag>;
                        return statusEle;
                    }
                },
                {
                    title: this.$t('port.login.phone_number',{defaultValue:'手机号'}),
                    key: "userLoginPhone"
                },
                {
                    title: "组织名称",
                    key: "companyName",
                    sortable: true
                },
                {
                    title: this.$t('global.common.address_information',{defaultValue:'地址信息'}),
                    key: "companyAddress"
                },
            ];
        }
    }
};
